import Link from "next/link"
import { useEffect, useState } from "react"

const BannerService = ({ item }) => {
  const { thumbnail_web } = item
  const [isMobile, setIsMobile] = useState(false)
  const [isTablet, setIsTablet] = useState(false)

  useEffect(() => {
    function handleResize() {
      setIsMobile(window.innerWidth < 768)
      setIsTablet(window.innerWidth >= 768 && window.innerWidth < 1024)
    }

    handleResize()
    window.addEventListener("resize", handleResize)
    return () => window.removeEventListener("resize", handleResize)
  }, [])

  return (
    <>
      {isMobile ? (
        <div className="relative rounded-xl mr-4">
          <img
            src={"/thumbnail_subscription_mobile.webp"}
            width={714}
            height={400}
            className="rounded-xl aspect-[358/200] fix_img"
            style={{ maxWidth: "100%", objectFit: "cover" }}
          />
          <div
            className="absolute bottom-0 left-0 right-0 px-3 py-3.5 flex justify-between items-center backdrop-blur-xl rounded-b-xl"
            style={{
              background: "linear-gradient(360deg, rgba(255, 255, 255, 0.3328) 0%, rgba(255, 255, 255, 0) 42%)"
            }}
          >
            <div className="flex flex-col gap-1 max-w-[167px]">
              <span className="text-base leading-[22px] text-[#fafaf9] font-semibold">Mua gói cước</span>
              <span className="text-xs font-normal text-secondary">
                Xem các giải đấu bản quyền chất lượng cao chỉ từ 8.000đ
              </span>
            </div>
            {/* <Link href="/subscription"> */}
            <div className="text-xs font-medium text-[#fafaf9] bg-primary rounded-lg py-1.5 px-3">Mua ngay</div>
            {/* </Link> */}
          </div>
        </div>
      ) : isTablet ? (
        <div className="relative rounded-xl mr-4">
          <img
            src={"/thumbnail_subscription_tablet.webp"}
            width={1472}
            height={400}
            className="rounded-xl aspect-[736/200] fix_img"
            style={{ maxWidth: "100%", objectFit: "cover" }}
          />
          <div
            className="absolute bottom-0 left-0 right-0 px-3 py-3.5 flex justify-between items-center backdrop-blur-xl rounded-b-xl"
            style={{
              background: "linear-gradient(360deg, rgba(255, 255, 255, 0.3328) 0%, rgba(255, 255, 255, 0) 42%)"
            }}
          >
            <div className="flex flex-col gap-1 max-w-[167px]">
              <span className="text-base leading-[22px] text-[#fafaf9] font-semibold">Mua gói cước</span>
              <span className="text-xs font-normal text-secondary">
                Xem các giải đấu bản quyền chất lượng cao chỉ từ 8.000đ
              </span>
            </div>
            {/* <Link href="/subscription"> */}
            <div className="text-xs font-medium text-[#fafaf9] bg-primary rounded-lg py-1.5 px-3">Mua ngay</div>
            {/* </Link> */}
          </div>
        </div>
      ) : (
        <div className="fix_img border-[3px] border-[#FFFFFF3D] rounded-xl overflow-hidden max-w-full flex justify-center max-md:mr-4 mr-8">
          {/* <Link href="/subscription"> */}
          <img src={thumbnail_web} width={1577} height={338} style={{ maxWidth: "100%", objectFit: "cover" }} />
          {/* </Link> */}
        </div>
      )}
    </>
  )
}

export default BannerService
